export default __webpack_public_path__ + "static/media/my-gifts-black.8f301a78.svg";